import { render, staticRenderFns } from "./CurrencyFilter.vue?vue&type=template&id=780ec62f&scoped=true"
import script from "./CurrencyFilter.vue?vue&type=script&lang=ts"
export * from "./CurrencyFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ec62f",
  null
  
)

export default component.exports